var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46191 7.43101C4.86871 3.76983 7.96334 1 11.6471 1V1C15.3308 1 18.4254 3.76983 18.8322 7.43101L19.1581 10.3638C19.2186 10.909 19.2489 11.1816 19.2971 11.4488C19.4366 12.2219 19.6892 12.9702 20.0468 13.6697C20.1704 13.9114 20.3115 14.1466 20.5937 14.617L21.4767 16.0887C22.2825 17.4316 22.6854 18.103 22.3981 18.6103C22.1109 19.1176 21.3278 19.1176 19.7617 19.1176H3.53238C1.96627 19.1176 1.18322 19.1176 0.89599 18.6103C0.608761 18.103 1.01164 17.4316 1.81739 16.0887L2.70038 14.617C2.98262 14.1466 3.12374 13.9114 3.24732 13.6697C3.60489 12.9702 3.85748 12.2219 3.99697 11.4488C4.04518 11.1816 4.07547 10.909 4.13605 10.3638L4.46191 7.43101Z",
    stroke: "#575757",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89688 19.6429C8.11808 20.606 8.60549 21.457 9.28352 22.064C9.96155 22.671 10.7923 23 11.6469 23C12.5016 23 13.3323 22.671 14.0104 22.064C14.6884 21.457 15.1758 20.606 15.397 19.6429",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnMute);
export default __webpack_public_path__ + "static/media/un_mute.20d57f871a7cacd91a029db2f6d93863.svg";
export { ForwardRef as ReactComponent };